/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from '../utils/axios'

/*
* 学生列表*/
export const getStudentList = function (
    data: {
        limit: string;
        page: string;
        customerName: string;
        customerCode: string;
        customerSource: string;
        code: string;
        souCourseTypeId: string;
        souCourseName: string;
        souCourseSchoolBegin: string; // 开课时间 // 格式：2023/12/08-2023/12/08
        isClasses: string; // 入班状态 // '0'-待入班; '1'-已入班; 允许值: '0', '1'
        classesName: string;
        classesCode: string;
        teacherUserId: string;
        thesisUserId: string;
        helperUserId: string;
    }
) {
    return axios.get('/student', {params: data})
}

/*
* 获取学生详情*/

export const getStudentById = function (
    id: string
) {
    return axios.get('/student/' + id)
}

/*
* 入班/批量入班*/
export const setStudentByclasserId = function (
    classerId: string,
    data: {
        idList: string[];
    }
) {
    return axios.put('/student/' + classerId, data)
}


/*
* 调班/批量调班*/
export const setStudentToNewClasserId = function (
    classerId: string,
    newClasserId: string,
    data: {
        idList: string[];
    }
) {
    return axios.put('/student/' + classerId + '/' + newClasserId, data)
}


/*
* 导出学生列表*/
export const exportStudent = function (
    data: {
        customerName: string;
        customerCode: string;
        customerSource: string;
        code: string;
        souCourseTypeId: string;
        souCourseName: string;
        souCourseSchoolBegin: string; // 开课时间 // 格式：2023/12/08-2023/12/08
        isClasses: string; // 入班状态 // '0'-待入班; '1'-已入班; 允许值: '0', '1'
        classesName: string;
        classesCode: string;
        teacherUserId: string;
        thesisUserId: string;
        helperUserId: string;
        keys?: string;
    }
) {
    return axios.get('/student/exportData', {params: data})
}


/*
* 统计数据*/
export const getStudentStaticData = function (
    data: {
        timeStr: string; /*时间区间*/
        groupByType: string;/*统计数据类型  // '0'-年级; '1'-专业; '2'-学校类型; '3'-留学需求; '4'-报名项目类型;*/
    }
) {
    return axios.get('/student/statisticalData', {params: data})
}

/*
* 班级列表*/
export const getClasses = function (
    data: {
        name?: string;
        code?: string;
        teacherUserId?: string;
        thesisUserId?: string;
        helperUserId?: string;
        souCourseTypeIdStr?: string;
        souCourseName?: string;
        souCourseSchoolBegin?: string; // 开课时间 // 格式：2023/12/08-2023/12/08
        teacherName?: string;
        projectAllId?: string; // 入班时使用
        limit?: string | number;
        page?: string | number;
    }
) {
    return axios.get('/classes', {params: data})
}

/*
* 班级详情*/
export const getClassesInfoById = function (
    id: string
) {
    return axios.get('/classes/' + id)
}


/*
* 编辑班级*/
export const updateClasses = function (
    id: string,
    data: {
        name: string;
        code: string;
        teacherUserId: string;
        thesisUserId: string;
        helperUserId: string;
    }
) {
    return axios.put('/classes/' + id, data)
}


/*
* 新建班级*/
export const addClasses = function (
    data: {
        name: string;
        code?: string;
        teacherUserId?: string;
        thesisUserId?: string;
        helperUserId?: string;
        projectAllId: number;
    }
) {
    return axios.post('/classes', data)
}


/*
* 删除班级*/
export const delClasses = function (
    data: {
        id: string;
    }
) {
    return axios.delete('/classes', {data})
}


/*
* 报名学员*/
export const getClassesCustomer = function (
    id: string,
    data: {
        grade?: string;
        customerName?: string;
        prevMarketCooperationName?: string;
        dissertationType?: string;
        isCredit?: string;
        limit?: string;
        page?: string;
    }
) {
    return axios.get('/classes/customer/' + id, {params: data})
}

/*
* 导出报名学员
* */
export const exportStudentData = function (
    id: string,
    data: {
        grade: string;
        customerName: string;
        prevMarketCooperationName: string;
        dissertationType: string;
        keys?: string;
    }
) {
    return axios.get('/classes/customer/' + id + '/exportData', {params: data})
}


/*
* 导出班级列表*/
export const exportClassesData = function (
    data: {
        name: string;
        code: string;
        teacherUserId: string;
        thesisUserId: string;
        helperUserId: string;
        souCourseTypeIdStr: string;
        souCourseName: string;
        souCourseSchoolBegin: string; // 开课时间 // 格式：2023/12/08-2023/12/08
        teacherName: string;
        keys?: string;
    }
) {
    return axios.get('/classes/exportData', {params: data})
}

/*
* 班级列表统计数据*/
export const getClassesStaticData = function (
    data: {
        timeStr: string;
        dateStr: string;
        souCourseTypeId: string;
    }
) {
    return axios.get('/classes/statisticalData', {params: data})
}
/*
* 服务完成/批量服务完成*/
export const setCustomerListFinishByClassId = function (
    data: {
        id: string;
        financeOrderIdList: object[];
        url: string;
        createdAt: string;
    }
) {
    return axios.post('/classes/customer', data)
}


/*
/classes/date
获取服务完成时间
*/
export const getClassesDate = function (){
    return axios.get('/classes/date')
}


/*
* 班级--论文产出--获取模版列表*/
export const getOutputTemplateList = function (
    data: {
        classesId: string;
        financeOrderId: string;
        types: string;
        page?: string;
        limit?: string;
    }
) {
    return axios.get('/output/template', {params: data})
}

/*保存产出 */
export const setOutputTemplate = function (
    data: {
        classesId: string;
        financeOrderId: string;
        subjectStr: string; //主题
        ccStr: string; //抄送
        bccStr: string; // 密送
        contentStr: string; // 正文
        attachmentList: [];
        isFinish: string;
        emailUser: string;
        types: string;
    }
) {
    return axios.post('/output', data)
}

/*
* 发送产出 ， 批量发送 产出*/
export const sendOutput = function (
    classesId: string,
    data: {
        financeOrderIdList: []; // 订单id List
    }
) {
    return axios.put('/output/' + classesId, data)
}

/*产出记录*/
export const getOutputRecord = function (
    data: {
        classesId: string;
        financeOrderId: string;
        types: string;
        page?: string;
        limit?: string;
    }
) {
    return axios.get('/output/studentOutput', {params: data})
}

/*查看产出记录详情*/
export const getOutputRecordInfoById = function (
    id: string
) {
    return axios.get('/output/studentOutput/' + id)
}

/*编辑保存产出记录*/
export const updateOutputRecord = function (
    id: string,
    data: {
        subjectStr: string; //主题
        ccStr: string; //抄送
        bccStr: string; // 密送
        contentStr: string; // 正文
        attachmentList: [];
        isFinish: string;
    }
) {
    return axios.put('/output/studentOutput/' + id, data)
}

/*发送产出记录*/
export const sendOutputRecord = function (
    id: string
) {
    return axios.put('/output/studentOutput/sendEmail/' + id)
}

/*获取产出模版列表*/
export const getOutputTemplate = function (
    data: {
        name?: string;
        souCourseTypeId?: string;
        createdUserId?: string;
        page?: string;
        limit?: string;
    }
) {
    return axios.get('/outputTemplate', {params: data})
}

/*新建产出模版*/
export const addOutputTemplate = function (
    data: {
        name: string;
        souCourseTypeId: number;
        subjectStr: string; //主题
        ccStr: string; //抄送
        bccStr: string; // 密送
        contentStr: string; // 正文
        emailUser: string;
    }
) {
    return axios.post('/outputTemplate', data)
}

/*查看产出模版*/
export const getOutputTemplateById = function (
    id: string
) {
    return axios.get('/outputTemplate/' + id)
}

/*编辑保存产出模版*/
export const updateOutputTemplate = function (
    id: string,
    data: {
        name: string;
        souCourseTypeId: string;
        subjectStr: string; //主题
        ccStr: string; //抄送
        bccStr: string; // 密送
        contentStr: string; // 正文
    }
) {
    return axios.put('/outputTemplate/' + id, data)
}

/*删除产出模版*/
export const delOutputTemplate = function (
    id: number
) {
    return axios.delete('/outputTemplate/' + id,)
}


/*获取邮箱列表*/
export const getEmailList = function () {
    return axios.get('/outputTemplate/email')
}


/*删除产出
* /output/studentOutput*/
export const delOutputRecord = function (
    id: string
) {
    return axios.delete('/output/studentOutput/' + id)
}